import { usePlanningTranslation } from '@libs/utils/translations'
import { Tube } from '@spa/scenes/Plannings/components'
import { memo } from 'react'
import type { FC } from 'react'

import { contractsSelectors } from '../../redux/selectors'

import styles from './ContractEntringExitingTube.module.css'

type Props = {
  className?: string
  contractId: number
  day: string
}
export const ContractEntringExitingTube: FC<Props> = memo(
  ({ className = '', contractId, day }) => {
    const { t } = usePlanningTranslation()
    const contract = contractsSelectors.useGetCachedById(contractId)

    const isContractStarting = contract?.contract_start === day
    const isContractEnding = contract?.contract_end === day
    const isContractOneDay = isContractStarting && isContractEnding

    if (!isContractStarting && !isContractEnding) {
      return null
    }

    return (
      <div className={className}>
        {isContractStarting && !isContractOneDay && (
          <Tube rounded className={styles.TubePadding}>
            <span className={styles.TubeText}>
              {t('daily.contractInfoStart')}
            </span>
          </Tube>
        )}
        {isContractEnding && !isContractOneDay && (
          <Tube rounded className={styles.TubePadding}>
            <span className={styles.TubeText}>
              {t('daily.contractInfoEnd')}
            </span>
          </Tube>
        )}
        {isContractOneDay && (
          <Tube rounded className={styles.TubePadding}>
            <span className={styles.TubeText}>
              {t('daily.contractInfoOneDay')}
            </span>
          </Tube>
        )}
      </div>
    )
  }
)
